import React from 'react';
import { Button, Space } from 'antd';
import { SubnodeOutlined } from '@ant-design/icons'
import { getNameByInspectionsKey, getDateFormatted, getDateFormattedInspection} from './utils';

export const buildColumn = (array) => array.map((item) => {

	if (item === 'startDate') {
		return {
			title: <b>F. de inicio</b>,
			key: 'startDate',
			render: (record) => (
				<Space>
					{getDateFormatted(record.startDate)}
				</Space>
			)
		};
	}
	if (item === 'startDate') {
		return {
			title: <b>F. de inicio</b>,
			key: 'startDate',
			render: (record) => (
				<Space>
					{getDateFormatted(record.startDate)}
				</Space>
			)
		};
	}

	if (item === 'createdAt') {
		return {
			title: <b>F. de alta</b>,
			key: 'createdAt',
			render: (record) => (
				<Space>
					{getDateFormatted(record.createdAt)}
				</Space>
			)
		};
	}

	if (item === 'endDate') {
		return {
			title: <b>F. de fin</b>,
			key: 'endDate',
			render: (record) => (
				<Space>
					{getDateFormatted(record.endDate)}
				</Space>
			)
		};
	}
	if (item === 'inspectionEndDate') {
		return {
			title: <b>F. fin inspección</b>,
			key: 'inspectionEndDate',
			render: (record) => (
				<Space>
					{getDateFormattedInspection(record.inspectionEndDate)}
				</Space>
			)
		};
	}
	if (item === 'inspectionStartDate') {
		return {
			title: <b>F. inicio inspección</b>,
			key: 'inspectionStartDate',
			render: (record) => (
				<Space>
					{getDateFormattedInspection(record.inspectionStartDate)}
				</Space>
			)
		};
	}


	if (item === 'events') {
		return {
			title: <b>Eventos seleccionados</b>,
			key: 'events',
			render: (record) => (
				<Space>
					{record.events}
				</Space>
			)
		};
	}
	if (item === 'reasons') {
		return {
			title: <b>Razones de Rechazo</b>,
			key: 'reasons',
			render: (record) => (
				<Space>
					{record.reasons}
				</Space>
			)
		};
	}
	if (item === 'inspector') {
		return {
			title: <b>Inspector</b>,
			key: 'inspector',
			render: (record) => (
				<Space>
					{record.inspectorFullName}
				</Space>
			)
		};
	}

	if (item === 'actionInspection') {
		return {
			title: <b>Acciones</b>,
			key: 'actionInspection',
			fixed: 'right',
			index: 15 ,
			width: 175,
			render: (record) => (
				<Space size="small">
					<Button type="primary" ghost onClick={record.getDetail} > Detalle </Button>
					<Button type="primary" ghost onClick={record.getDetailOtherTab} > <SubnodeOutlined /> </Button>
				</Space>

			)
		};
	}

	return {
		title: getNameByInspectionsKey(item),
		dataIndex: item
	};
});



export const inspectionApplicationsColumn = buildColumn(['upCode','inspectorInternalCode', 'inspector', 'inspectionType', 'currentStatus','createdAt', 'startDate', 'endDate', 'actionInspection']);
export const inspectionColumn = buildColumn(['id','inspectorInternalCode', 'inspector', 'createdAt', 'startDate', 'endDate', 'inspectionType','inspectionStartDate','inspectionEndDate', 'currentStatus']);
export const establishmentColumn = buildColumn(['establishmentCode', 'establishmentName', 'establishmentZone', 'inspectionExportZone', 'establishmentDirection']);
export const eventsColumn = buildColumn(['events']);
export const reasonForRejectionColumn = buildColumn(['reasons']);



